/*------------------------------------*\
    product page
\*------------------------------------*/

module.exports = function(){

    var mySwiper;

    // Content height must match photo height

    var $windowWidth = $(window).width();
    var $productPhoto = $('.js-product-photo');
    var $productInfo = $('.js-product-info');
    var $productDescription = $('.js-product-description');
    var $productCustomize = $('.js-product-customize');
    // var $productInfoMore = $('.js-product-info-more');

    if(($productPhoto.height() < $productInfo.height()) && ($windowWidth >= 900)) {
        $productInfo.css({'height': $productPhoto.height()});
        // $productInfoMore.fadeIn();
    }




    if (currentTemplate == 'product') {
        mySwiper = new Swiper ('.swiper-container', {
            direction: 'horizontal',
            effect: 'fade',
            speed: 1000,
            loop: true,
            lazyLoading: true,
            nextButton: '.swiper-button-next',
            prevButton: '.swiper-button-prev',
            pagination: '.swiper-pagination',
            paginationType: 'bullets',
            paginationClickable: true,
            autoHeight: false,
            paginationBulletRender: function(index, className) {
                return '<span class="slider__bullet ' + className + '"></span>';
            },
            breakpoints: {
                700: {
                    autoHeight: false,
                },
            },
        });
    }








    $(window).load(function() {




        // Content height must match photo height

        $windowWidth = $(window).width();
        $productPhoto = $('.js-product-photo');
        $productInfo = $('.js-product-info');
        $productDescription = $('.js-product-description');
        $productCustomize = $('.js-product-customize');
        // var $productInfoMore = $('.js-product-info-more');

        if(($productPhoto.height() < $productInfo.height()) && ($windowWidth >= 900)) {
            $productInfo.css({'height': $productPhoto.height()});
            // $productInfoMore.fadeIn();
        }


        $(window).trigger('resize');

        // Overflow content should scroll on button hover

        // function overflowScroll(scrollDiv) {
        //     scrollDiv.animate({
        //         scrollTop: amount
        //     }, 100, 'linear', function() {
        //         if(amount != '') {
        //             overflowScroll(scrollDiv);
        //         }
        //     });
        // }

        // $productInfoMore.hover(function() {
        //     amount = '+=10';
        //     overflowScroll($productInfo);
        //     if($productInfo.scrollTop() == $productInfo[0].scrollHeight - $productInfo.outerHeight()) {
        //         amount = '-=10';
        //         $('.js-product-info-more-icon').css({'transform': 'rotate(180deg)'});
        //     } else {
        //         $('.js-product-info-more-icon').css({'transform': 'rotate(0deg)'});
        //     }
        // }, function() {
        //     amount = '';
        //     if($productInfo.scrollTop() == $productInfo[0].scrollHeight - $productInfo.outerHeight()) {
        //         $('.js-product-info-more-icon').css({'transform': 'rotate(180deg)'});
        //     } else {
        //         $('.js-product-info-more-icon').css({'transform': 'rotate(0deg)'});
        //     }
        // });

        // Customize section



    });







    $(window).resize(function() {
        $windowWidth = $(window).width();
        if($windowWidth >= 900) {
            $productInfo.css({'height': $productPhoto.height()});
        }
    });







    $(document).on('click', '.js-product-customize-trigger', function(e) {
        e.preventDefault();
        //console.warn('.js-product-customize-trigger click - product-n-customize.js');

        //console.log('v2 - clicked js-product-customize-trigger')

        if (!!$(this).data('is-multiple')) {
            //console.log('v2 - item to be customized is multiple, invoking alert')
            alertify.alert('Please remove this item from your cart and then add it again to edit customization.')
            return;
        }

        $productDescription.removeClass('is-current');
        $productCustomize.addClass('is-current');
        $productInfo.animate({scrollTop: '-100%'}, 500);

        mySwiper.stopAutoplay();

        if($productPhoto.height() < $('.js-product-customize').height()) {

            if($windowWidth >= 900) {
                $productInfo.css({'height': $productPhoto.height()});
            }
            // $productInfoMore.fadeIn();

        // } else {
        //     $productInfoMore.fadeOut();
        }



        //Align window with customization space
        if ($(window).width() < 900 ) {

            $('html, body').animate({
                scrollTop: $('.js-product-customize-form').offset().top - 100
            }, 500);

        }


    });








    // Back button

    $('.js-product-description-trigger').on('click', function(e) {
        $productCustomize.removeClass('is-current');
        $productDescription.addClass('is-current');
        $productDescription.animate({scrollTop: '-100%'}, 500);

        mySwiper.stopAutoplay();
        e.preventDefault();

        if($productPhoto.height() < $('.js-product-customize').height()) {

            if($windowWidth >= 900) {
                $productInfo.css({'height': $productPhoto.height()});
            }
            // $productInfoMore.fadeIn();

        // } else {
        //     $productInfoMore.fadeOut();
        }


        $('.js-step').removeClass('is-current');
        //$('.js-step[data-step="1"]').addClass('is-current');

        $('.js-step-trigger').removeClass('is-current');
        //$('.js-step-trigger[data-step="1"]').addClass('is-current');

    });






}; // end of module.exports



// WEBPACK FOOTER //
// ./js-source/blocks/product-n-customize.js